export default "__VITE_ASSET__DkRbmwbg__"